import { FC, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { EXTERNAL, PATHS } from "../../paths";
import Icon from "../components/Icon";

interface NavChild {
  label: string;
  to: string;
}

interface NavItem {
  label: string;
  to: string;
  children?: NavChild[];
}

const MOBILE_BREAKPOINT = 960;

const NAV_ITEMS: NavItem[] = [
  { label: "Anasayfa", to: PATHS.home },
  {
    label: "Hakkımızda",
    to: PATHS.about,
    children: [
      { label: "Securitas İtfaiye", to: PATHS.about },
      { label: "Securitas Grup", to: PATHS.group },
      { label: "Değerlerimiz", to: PATHS.values },
      { label: "Kalite Yönetim Programı", to: PATHS.quality },
    ],
  },
  {
    label: "Hizmetlerimiz",
    to: PATHS.fire,
    children: [
      { label: "İtfaiye Hizmeti", to: PATHS.fire },
      { label: "Gözlem Hizmeti", to: PATHS.watch },
      { label: "Multi Rol Güvenlik Görevlisi", to: PATHS.multiRole },
    ],
  },
  { label: "Eğitimlerimiz", to: PATHS.trainings },
  { label: "Blog", to: PATHS.blog },
];

const isItemActive = (item: NavItem, pathname: string) => {
  if (item.to === PATHS.home) return pathname === PATHS.home;
  if (item.children) {
    return item.children.some((child) => pathname === child.to);
  }
  return pathname === item.to || pathname.startsWith(`${item.to}/`);
};

const Header: FC = () => {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [expanded, setExpanded] = useState<string | null>(null);

  useEffect(() => {
    setMenuOpen(false);
    setExpanded(null);
  }, [pathname]);

  return (
    <header className="it-header">
      <div className="it-wrap it-nav-row">
        <Link className="it-brand" to={PATHS.home} aria-label="Securitas İtfaiye Anasayfa">
          <img
            src="/uploads/2017/12/footerlogo-sol.png"
            alt="Securitas İtfaiye"
            width={51}
            height={46}
          />
        </Link>

        <nav
          className={`it-nav${menuOpen ? " open" : ""}`}
          id="mainNav"
          aria-label="Ana menü"
        >
          <ul>
            {NAV_ITEMS.map((item) => (
              <li key={item.label} className={expanded === item.label ? "exp" : undefined}>
                <Link
                  to={item.to}
                  className={isItemActive(item, pathname) ? "active" : undefined}
                  onClick={(event) => {
                    if (item.children && window.innerWidth <= MOBILE_BREAKPOINT) {
                      event.preventDefault();
                      setExpanded(expanded === item.label ? null : item.label);
                      return;
                    }
                    setMenuOpen(false);
                  }}
                >
                  {item.label}
                  {item.children && <Icon name="caret" className="it-caret" />}
                </Link>
                {item.children && (
                  <div className="it-dd">
                    {item.children.map((child) => (
                      <Link
                        key={child.to}
                        to={child.to}
                        className={pathname === child.to ? "active" : undefined}
                        onClick={() => setMenuOpen(false)}
                      >
                        {child.label}
                      </Link>
                    ))}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div className="it-nav-right">
          <a
            className="it-contact"
            href={EXTERNAL.contact}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="mail" />
            <span>Bize Ulaşın</span>
          </a>
          <a
            className="it-sec-logo"
            href={EXTERNAL.securitas}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Securitas"
          >
            <img src="/uploads/logo.svg" alt="Securitas" width={62} height={33} />
          </a>
          <button
            type="button"
            className="it-burger"
            aria-label={menuOpen ? "Menüyü kapat" : "Menüyü aç"}
            aria-expanded={menuOpen}
            aria-controls="mainNav"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <Icon name="menu" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
